<template>
  <div>
    <footer class="footer">
      <div class="container ft">
        <p class="text-right ftp">
          <router-link to="/privacy" class="fta">隐私政策</router-link>|
          <a href="#" class="fta">重要通知</a>|
          <router-link to="/aboutUs" class="fta">关于我们</router-link>|
          <router-link to="/contact" class="fta">联系方式</router-link>
        </p>
        <p class="text-right">
          <small class="text-black-50">
            Copyright&copy;高等教育出版社 京ICP备12020869号-1 京ICP证150856号
            京公网安备11010202008535
          </small>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
@import url("../assets/style.css");
@import url("../assets/bootstrap.css");
</style>
